import Guard from 'arg-guard'

import KeyEvent from '../models/key-event'

/*
 * Queries for input characters.
 */

export default {

    /**
     * Determines if a character is an alpha character.
     *
     * @param {string} character
     * @returns {boolean} A flag to indicate if the character is an alpha.
     */
    isAlpha(character) {
        Guard.throwIf(character, 'character')
        if (character.length > 1) throw new TypeError('Only a single character is valid for this method.')

        const regex = new RegExp(/^[a-zA-Z]*$/)
        return regex.test(character)
    },

    /**
     * Determines if a character is a number.
     *
     * @param {string} character
     * @returns {boolean} A flag to indicate if the character is a number.
     */
    isNumber(character) {
        Guard.throwIf(character, 'character')
        if (character.length > 1) throw new TypeError('Only a single character is valid for this method.')

        const regex = new RegExp(/^\d+$/)
        return regex.test(character)
    },

    /**
     * Determines if a character is a symbol.
     *
     * @param {string} character
     * @returns {boolean} A flag to indicate if the character is a symbol.
     */
    isSymbol(character) {
        Guard.throwIf(character, 'character')
        if (character.length > 1) throw new TypeError('Only a single character is valid for this method.')

        return !this.isAlpha(character) && !this.isNumber(character)
    },

    /**
     * Determines if a character is in a permitted character array.
     *
     * @param {string} character
     * @param {Array} allowedcharacters = []
     * @returns {boolean} A flag to indicate if the character is in the array.
     */
    isIn(character, allowedcharacters = []) {
        Guard.throwIf(character, 'character')
        if (character.length > 1) throw new TypeError('Only a single character is valid for this method.')

        return allowedcharacters.includes(character)
    },

    /**
     * Queries the event data to use to identify a ky of a specified name.
     *
     * @param {string} keyName The name of the event
     * @returns {KeyEvent} A set of event data
     */
    queryEventData(keyName) {
        switch (keyName) {
            case 'backspace':
                return new KeyEvent(keyName, 8)
            case 'tab':
                return new KeyEvent(keyName, 9)
            case 'enter':
                return new KeyEvent(keyName, 13)
            case 'escape':
                return new KeyEvent(keyName, 27)
            case 'space':
                return new KeyEvent(keyName, 32, { key: ' ' })
            case 'page up':
                return new KeyEvent(keyName, 33, { key: 'PageUp', code: 'PageUp' })
            case 'page down':
                return new KeyEvent(keyName, 34, { key: 'PageDown', code: 'PageDown' })
            case 'delete':
                return new KeyEvent(keyName, 46)
            default:
                throw new TypeError('Invalid keyName provided or keyName not yet supported: see https://www.freecodecamp.org/news/javascript-keycode-list-keypress-event-key-codes/#:~:text=A%20Full%20List%20of%20Key%20Event%20Values%20,%20%20%20%2076%20more%20rows%20 to add more.')
        }
    },
}
